export const fakeHistory = {
  participants: [
    {
      id: 2,
      characterId: 3,
      factionId: 1,
      firstName: "Моисей",
      lastName: "Власов",
      inOnline: true,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 12,
      rankPositionId: 12,
      departmentId: 11,
      reason: "Долбоеб",
      action: "Пригласил во фракцию",
    },
    {
      id: 3,
      characterId: 4,
      factionId: 1,
      firstName: "Иван",
      lastName: "Иванов",
      inOnline: true,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 12,
      rankPositionId: 8,
      departmentId: 7,
    },
    {
      id: 4,
      characterId: 25,
      factionId: 1,
      firstName: "Александр",
      lastName: "Иванов",
      inOnline: false,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 9,
      rankPositionId: 1,
      departmentId: 3,
    },
    {
      id: 5,
      characterId: 26,
      factionId: 1,
      firstName: "Дмитрий",
      lastName: "Петров",
      inOnline: false,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 8,
      rankPositionId: 5,
      departmentId: 4,
    },
    {
      id: 6,
      characterId: 27,
      factionId: 1,
      firstName: "Дмитрий",
      lastName: "Петров",
      inOnline: false,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 8,
      rankPositionId: 5,
      departmentId: 4,
    },
    {
      id: 7,
      characterId: 28,
      factionId: 1,
      firstName: "Дмитрий",
      lastName: "Петров",
      inOnline: false,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 8,
      rankPositionId: 5,
      departmentId: 4,
    },
    {
      id: 8,
      characterId: 29,
      factionId: 1,
      firstName: "Дмитрий",
      lastName: "Петров",
      inOnline: false,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 8,
      rankPositionId: 5,
      departmentId: 4,
    },
    {
      id: 9,
      characterId: 30,
      factionId: 1,
      firstName: "Дмитрий",
      lastName: "Петров",
      inOnline: false,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 8,
      rankPositionId: 5,
      departmentId: 4,
    },
  ],
  finance: [
    {
      id: 2,
      characterId: 3,
      factionId: 1,
      firstName: "Моисей",
      lastName: "Власов",
      inOnline: true,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 12,
      rankPositionId: 12,
      departmentId: 11,
      reason: "Долбоеб",
      action: "Пригласил во фракцию",
    },
    {
      id: 3,
      characterId: 4,
      factionId: 1,
      firstName: "Иван",
      lastName: "Иванов",
      inOnline: true,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 12,
      rankPositionId: 8,
      departmentId: 7,
    },
  ],
  warehouse: [
    {
      id: 2,
      characterId: 3,
      factionId: 1,
      firstName: "Моисей",
      lastName: "Власов",
      inOnline: true,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 12,
      rankPositionId: 12,
      departmentId: 11,
      reason: "Долбоеб",
      action: "Пригласил во фракцию",
    },
    {
      id: 3,
      characterId: 4,
      factionId: 1,
      firstName: "Иван",
      lastName: "Иванов",
      inOnline: true,
      onlineTimeInAWeek: 0,
      dutyTimeInAWeek: 0,
      createdAt: "2025-10-13T12:35:00.000Z",
      rankId: 12,
      rankPositionId: 8,
      departmentId: 7,
    },
  ],
};
